'use client'

import type { Dispatch, SetStateAction } from 'react'
import { useTranslations } from 'next-intl'
import { cx } from 'class-variance-authority'

export type PeriodOption = {
  label: string
  period: string
  value: number | null
}

type ChoosePeriodCardProps<T extends PeriodOption> = {
  period: T
  setPeriod: Dispatch<SetStateAction<T>>
  timePeriod: readonly T[]
}

export const ChoosePeriodCard = <T extends PeriodOption>({
  period,
  setPeriod,
  timePeriod,
}: ChoosePeriodCardProps<T>) => {
  const t = useTranslations()

  return (
    <div
      className="inline-flex w-fit shrink-0 self-start flex-wrap gap-1 rounded-lg border border-zinc-200 bg-zinc-50/80 p-1"
      role="group"
      aria-label={t('Common.analysis-period')}
    >
      {timePeriod.map((time) => {
        const isSelected = time.period === period.period

        return (
          <button
            key={time.period}
            type="button"
            onClick={() => setPeriod(time)}
            aria-pressed={isSelected}
            className={cx(
              'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
              isSelected
                ? 'bg-white text-slate-900 shadow-sm ring-1 ring-zinc-200'
                : 'text-slate-500 hover:text-slate-800',
            )}
          >
            {time.label}
          </button>
        )
      })}
    </div>
  )
}
